// ui
import { Icon, IconProps } from "@chakra-ui/react";

export const ChevronFillIcon = (props: IconProps) => (
  <Icon viewBox="0 0 48 48" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.0828 8.53281C15.4918 8.53281 8.53281 15.4918 8.53281 24.0828C8.53281 32.6738 15.4918 39.6328 24.0828 39.6328C32.6738 39.6328 39.6328 32.6738 39.6328 24.0828C39.6328 15.4918 32.6738 8.53281 24.0828 8.53281ZM7.13281 24.0828C7.13281 14.7186 14.7186 7.13281 24.0828 7.13281C33.447 7.13281 41.0328 14.7186 41.0328 24.0828C41.0328 33.447 33.447 41.0328 24.0828 41.0328C14.7186 41.0328 7.13281 33.447 7.13281 24.0828Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M27.1754 16.522C27.451 16.7932 27.4544 17.2364 27.1832 17.5119L20.9765 23.8168L20.4926 23.3405L20.9765 23.8168C20.8537 23.9416 20.8537 24.1 20.9765 24.2248L20.4776 24.7158L20.9765 24.2248L27.1832 30.5297C27.4544 30.8052 27.451 31.2484 27.1754 31.5196C26.8999 31.7909 26.4567 31.7874 26.1855 31.5119L19.9788 25.2069C19.3196 24.5373 19.3196 23.5043 19.9788 22.8347L20.4776 23.3258L19.9788 22.8347L26.1855 16.5297C26.4567 16.2542 26.8999 16.2507 27.1754 16.522Z"
      fill="currentColor"
    />
  </Icon>
);
